import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'guestTrialLandingShown',
  'guestTrialDemoPlayed',
  'guestTrialDemoSoundEnabled',
  'guestTrialDemoPaused',
  'guestTrialDemoProgress',
  'guestTrialCheckoutClick',
  'guestTrialOpenInBrowser',
  'guestTrialCheckoutViewed',
  'guestTrialWalletsAvailable',
  'guestTrialPaymentMethodSelected',
  'guestTrialPaymentSubmitted',
  'guestTrialPaymentFailed',
  'guestTrialCheckoutBack',
  'guestTrialSignupClick',
  'guestTrialCancelled',
] as const;

const EXIT_EVENTS = ['guestTrialDemoWatched'] as const;

const CONVERSION_EVENTS = ['guestTrialPaymentConfirmed', 'guestTrialAccountActivated'] as const;

export const guestTrialEvents = [
  ...getMappedEvents([...EVENTS]),
  ...getMappedEvents([...EXIT_EVENTS], { shouldSendImmediately: true }),
  ...getMappedEvents([...CONVERSION_EVENTS], { shouldSendImmediately: true }),
];
